import { useMemo } from 'react';

import { prop } from '@ipfabric/utils/fp/prop';
import { LicenseLimitChecker } from '@ipfabric/utils/license/licenseLimitChecker';

import { useGlobalStateContextSelectors } from './GlobalStateModel';

export function useLicenseChecker(): LicenseLimitChecker {
  const { license } = useGlobalStateContextSelectors({
    license: prop('license'),
  });

  // Whole slice passed through (not just `devices`) — CCU fields land here later
  // without touching this hook again; the object is small and rarely changes,
  // so the extra fields cost nothing re: reactivity. An unknown `devices` is
  // handled by LicenseLimitChecker itself, so no null-check needed here.
  return useMemo(() => new LicenseLimitChecker(license), [license]);
}
